import React from 'react';
import { usePluginRegistry } from '../../plugins/registry.js';
import DashboardLayout from '../../components/DashboardLayout.js';

const SettingsPage: React.FC = () => {
  const pluginRegistry = usePluginRegistry();
  const settingsPlugin = pluginRegistry.getPlugin('settings-plugin');
  
  if (!settingsPlugin || !settingsPlugin.isEnabled) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-slate-300 mb-2">Settings Unavailable</h2>
          <p className="text-slate-400">The settings plugin is not available or disabled.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-950">
      <DashboardLayout activePluginId="settings-plugin" />
    </div>
  );
};

export default SettingsPage;
